module.exports = __webpack_public_path__ + "assets/accountInfo.svg";


//////////////////
// WEBPACK FOOTER
// ./libs/images/accountInfo.svg
// module id = 347
// module chunks = 0